import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Stack } from '@mui/material';

import { Checkbox, MenuPanel } from 'components/simple';

const styles = {
  footer: {
    marginTop: 1,
    paddingInline: 2,
  },
  button: ({ breakpoints }) => ({
    [breakpoints.up('lg')]: {
      minWidth: 'unset',
      flex: 1,
      padding: 1,
    },
  }),
};

export const MultiSelectFilterPanel = ({ valueOptions, filterValue, onChangeFilterModel }) => {
  const [selectedFilters, setSelectedFilters] = useState(filterValue ?? []);

  const handleSelectFilter = (updatedValue, isSelected) => {
    setSelectedFilters((prevSelectedFilters) =>
      isSelected
        ? [...prevSelectedFilters, updatedValue]
        : prevSelectedFilters.filter((value) => value !== updatedValue),
    );
  };

  const handleApplyFilters = () => {
    onChangeFilterModel(selectedFilters);
  };

  const handleResetFilters = () => {
    onChangeFilterModel(null);
  };

  const options = valueOptions.map((option) => {
    const isSelected = selectedFilters.includes(option.value);

    return {
      key: option.value,
      label: option.label,
      selected: isSelected,
      icon: <Checkbox checked={isSelected} />,
      onClick: () => handleSelectFilter(option.value, !isSelected),
    };
  });

  return (
    <>
      <MenuPanel options={options} />

      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2} width="100%" sx={styles.footer}>
        <Button variant="outlined" onClick={handleResetFilters} sx={styles.button}>
          Reset
        </Button>

        <Button variant="contained" onClick={handleApplyFilters} sx={styles.button}>
          Apply
        </Button>
      </Stack>
    </>
  );
};

MultiSelectFilterPanel.propTypes = {
  onChangeFilterModel: PropTypes.func.isRequired,
  filterValue: PropTypes.arrayOf(PropTypes.string).isRequired,
  valueOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
};
